import { render, staticRenderFns } from "./MintalMesPrdSubstationPowerRecordEdit.vue?vue&type=template&id=0c9e906f&"
import script from "./MintalMesPrdSubstationPowerRecordEdit.vue?vue&type=script&lang=js&"
export * from "./MintalMesPrdSubstationPowerRecordEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports